import { useCallback, useState } from 'react';
import { DRAWER_TRANSITION_DURATION } from 'src/components/Drawers/consts';
import useSyncedRef from 'src/hooks/utils/useSyncedRef';

interface Params {
	onClose: () => void;
}

/**
 * Provides a function to close the bottom drawer, along with a boolean indicating
 * if it's currently closing. When passed to `BottomDrawer` (and any comnponent that
 * can close it), these utils ensure the drawer closes with a transition.
 */
export default function useCloseBottomDrawer({ onClose }: Params) {
	const [isDrawerClosing, setIsDrawerClosing] = useState(false);
	const onCloseRef = useSyncedRef(onClose);

	const closeDrawer = useCallback(() => {
		setIsDrawerClosing(true);

		setTimeout(() => {
			onCloseRef.current();
			setIsDrawerClosing(false);
		}, DRAWER_TRANSITION_DURATION);
	}, [onCloseRef]);

	return { closeDrawer, isDrawerClosing };
}
